import { render } from "./SignModal.vue?vue&type=template&id=ad966d40&scoped=true"
import script from "./SignModal.vue?vue&type=script&lang=js"
export * from "./SignModal.vue?vue&type=script&lang=js"

import "./SignModal.vue?vue&type=style&index=0&id=ad966d40&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad966d40"]])

export default __exports__